import React from 'react';
import { GroupAddons } from './Addons/Group';
import { ServiceData, SlotService } from '../../../../utils/state/types';
import { mapToArray } from '../../../../utils';
import { useFormActions } from '../../Hooks/useFormActions';
import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
import { PaymentType } from '../../../../types/types';
import {
  Text,
  SectionNotification,
  SectionNotificationType,
} from 'wix-ui-tpa/cssVars';
import { classes } from './AddonsDetails.st.css';
import { useTranslation } from '@wix/yoshi-flow-editor';

export const AddonsDetails = ({
  serviceData,
  participantIndex,
}: {
  serviceData: ServiceData;
  participantIndex?: number;
}) => {
  const { onAddonSelect, onAddonQuantityChange } = useFormActions();
  const singleService = mapToArray<SlotService>(serviceData.slotServices)[0];
  const {
    addOnByGroup,
    selectedAddons = {},
    service,
    selectedPaymentOption,
    participantAddons,
  } = singleService;
  const activeSelectedAddons =
    participantIndex === undefined
      ? selectedAddons
      : participantAddons?.[participantIndex] ?? {};
  const serviceSlotId = singleService.nestedSlot.lineItemId;
  const { t } = useTranslation();

  const shouldShowAddons = (
    paymentType: string,
    hasActivePlan: boolean,
  ): boolean => {
    if (paymentType !== PaymentType.BUY_PLAN) {
      return true;
    }
    return hasActivePlan;
  };

  if (
    service.type === ServiceType.APPOINTMENT ||
    selectedPaymentOption?.type === PaymentType.SUBSCRIPTION ||
    !addOnByGroup ||
    addOnByGroup?.length === 0
  ) {
    return null;
  }

  const showAddons = shouldShowAddons(
    selectedPaymentOption?.type || '',
    !!selectedPaymentOption?.creditRemain,
  );

  return (
    <div className={classes.addon_group}>
      <Text className={classes.title}>
        {t('app.bookings-form.add-ons.section.title')}
      </Text>
      {!showAddons ? (
        <div className={classes.notification}>
          <SectionNotification type={SectionNotificationType.wired}>
            <SectionNotification.Text>
              {t('app.bookings-form.add-ons.select-plan-message')}
            </SectionNotification.Text>
          </SectionNotification>
        </div>
      ) : (
        addOnByGroup
          ?.filter((group) => group.addOns?.length)
          .map((group) => {
            return (
              <GroupAddons
                key={group.id}
                groupId={group.id!}
                name={group.name!}
                addOns={group.addOns!}
                maxQuantity={group.maxNumberOfAddOns ?? undefined}
                prompt={group.prompt ?? undefined}
                selectedAddons={activeSelectedAddons}
                onAddonSelect={(addonId, isSelected) =>
                  onAddonSelect(
                    addonId,
                    isSelected,
                    serviceSlotId,
                    participantIndex,
                  )
                }
                onAddonQuantityChange={(addonId, quantity) =>
                  onAddonQuantityChange(
                    addonId,
                    quantity,
                    serviceSlotId,
                    participantIndex,
                  )
                }
              />
            );
          })
      )}
    </div>
  );
};
